import { Route, Routes, useLocation } from "react-router-dom";
import { AppMenu } from "./components/AppMenu";
import { HomePage } from "./pages/HomePage";
import { ChartPage } from "./pages/ChartPage";
import { AdminPage } from "./pages/AdminPage";
import { AdminEntryPage } from "./pages/AdminEntryPage";
import { TvPage } from "./pages/TvPage";

export function App() {
  const location = useLocation();
  const showFixedMenu = location.pathname !== "/";

  return (
    <div className="app-root">
      {showFixedMenu ? <AppMenu variant="fixed" /> : null}
      <main
        className={`app-main ${showFixedMenu ? "app-main--footer-menu" : ""}`}
      >
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/chart" element={<ChartPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/entry" element={<AdminEntryPage />} />
          <Route path="/tv" element={<TvPage />} />
        </Routes>
      </main>
    </div>
  );
}
